import React from 'react';
import ErrorPage from 'components/shared/ErrorPage';

const IntentionallyThrowError = () => {
  throw new Error('Intentionally threw an error! Please ignore QA');
};

export default function withErrorBoundary(WrappedComponent) {
  return class ErrorPageBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: null };
    }

    componentDidCatch = (error, errorInfo) => {
      this.setState({ hasError: true, error });
      console.error(error, errorInfo);
    };

    render() {
      if (this.state.hasError) {
        return <ErrorPage error={this.state.error} />;
      }

      if (this.props.throwError) {
        return <IntentionallyThrowError />;
      }

      return <WrappedComponent {...this.props} />;
    }
  };
}
